import { useLocation } from "react-router-dom";
import SeoMeta from "./SeoMeta";
import { seoPages } from "./seoConfig";

// Older tool pages have no local Helmet; keep their browser metadata in sync with the build.
export default function RouteSeo() {
  const { pathname } = useLocation();
  const page = seoPages[pathname.replace(/\/+$/, "") || "/"];
  return page?.routeManaged ? <SeoMeta page={page} includeCanonical={false} /> : null;
}
